import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

export const MyWatchlistWrapper = styled.div`
  padding: 0 8px 10px 8px;
`;

export const MyWatchlistResult = styled.div`
  border-radius: 4px;
  border: 1px solid ${color.downgray};
  padding: 12px 16px 6px 16px;

  .item:not(:last-child) {
    border-bottom: 1px solid ${color.downgray};
  }
`;

export const SkeletonItemText = styled(Flex)`
  height: 20px;
  border-radius: 4px;
  background-color: #F6F6F6;
`;

export const SkeletonItemCheckbox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;

  .checkbox {
    width: 15.417px;
    height: 15.417px;
    border: 1px solid ${color.downgray};
    border-radius: 50%;
  }
`;
